module.exports = __webpack_public_path__ + "media/images/CC-logo-light-c972c774.png";